export default "__VITE_ASSET__DI8O0CvG__"